export const DESCRIPTION_COLOR_ERROR = 'colors_not_allowed';

const FORBIDDEN_TAG_PATTERN = /<\/?(?:price|font)\b/i;
const FORBIDDEN_ATTRIBUTE_PATTERN = /\s(?:color|bgcolor)\s*=/i;
const STYLE_ATTRIBUTE_PATTERN = /\bstyle\s*=\s*(["'])(.*?)\1/gis;
const STYLE_COLOR_PROPERTY_PATTERN = /(?:color|background-color|background)\s*:/i;

export function containsForbiddenColor(html) {
  if (html === null || html === undefined || html === '') {
    return false;
  }

  const value = String(html);

  if (FORBIDDEN_TAG_PATTERN.test(value) || FORBIDDEN_ATTRIBUTE_PATTERN.test(value)) {
    return true;
  }

  return containsColorInStyleAttributes(value);
}

function containsColorInStyleAttributes(html) {
  let match = STYLE_ATTRIBUTE_PATTERN.exec(html);

  while (match) {
    if (STYLE_COLOR_PROPERTY_PATTERN.test(match[2])) {
      return true;
    }

    match = STYLE_ATTRIBUTE_PATTERN.exec(html);
  }

  return false;
}

function getItemLang(item) {
  if (!item) {
    return null;
  }

  if (item.lang_code) {
    return item.lang_code;
  }

  if (item.lang) {
    return item.lang;
  }

  return null;
}

function getItemValue(item) {
  if (!item || item.value === null || item.value === undefined) {
    return '';
  }

  return item.value;
}

export function normalizeMultilangValues(values) {
  if (Array.isArray(values)) {
    const normalized = {};

    values.forEach(function (item) {
      const lang = getItemLang(item);

      if (!lang) {
        return;
      }

      normalized[lang] = getItemValue(item);
    });

    return normalized;
  }

  if (values && typeof values === 'object') {
    return values;
  }

  return {};
}

export function multilangColorValidationErrors(
  values,
  languages,
  fieldPrefix,
  errorCode
) {
  const normalized = normalizeMultilangValues(values);
  const langs = languages && languages.length ? languages : Object.keys(normalized);
  const errors = {};
  const prefix = fieldPrefix || 'description';
  const code = errorCode || DESCRIPTION_COLOR_ERROR;

  langs.forEach(function (langCode) {
    const text = normalized[langCode];

    if (typeof text === 'string' && containsForbiddenColor(text)) {
      errors[prefix + '|' + langCode] = code;
    }
  });

  return errors;
}
